import { Accordion } from "@szhsin/react-accordion";
import { COLORS_OPTIONS } from "constants/options";
import { convertSearchParamsToObject } from "helpers";
import { useTranslation } from "react-i18next";
import { createSearchParams, useSearchParams } from "react-router-dom";
import { SelectableItem, SelectableList } from "ui";

import { COLORS_FILTER_SEARCH_PARAMETER } from "../../../../constants";
import { FilterAccordion } from "../FilterAccordion";
import { ColorsFilterProps } from "./ColorsFilter.types";

const ColorsFilter = ({ colorAttributeValues }: ColorsFilterProps) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const colorsOptions = colorAttributeValues
    ? COLORS_OPTIONS.filter((option) =>
        colorAttributeValues.some(
          (attributeValue) => attributeValue.value === option.value
        )
      )
    : COLORS_OPTIONS;

  const colorsSearchParameterValue = searchParams.getAll(
    COLORS_FILTER_SEARCH_PARAMETER
  );
  const colorsListValue = colorsOptions.filter((option) =>
    colorsSearchParameterValue.includes(option.value)
  );

  const onSelectableColorsListChange = (
    selectableColorOptions: SelectableItem[]
  ) => {
    const existingParams = convertSearchParamsToObject(searchParams);
    const newColorsParametr = selectableColorOptions.map(
      (option) => option.value
    );

    setSearchParams(
      createSearchParams({
        ...existingParams,
        [COLORS_FILTER_SEARCH_PARAMETER]: newColorsParametr
      })
    );
  };

  const clearColorsFilter = () => {
    searchParams.delete(COLORS_FILTER_SEARCH_PARAMETER);
    setSearchParams(searchParams);
  };

  return (
    <Accordion transition transitionTimeout={250}>
      <FilterAccordion
        header={t("Colors")}
        isClearDisplay={colorsSearchParameterValue.length > 0}
        onClearClick={clearColorsFilter}
      >
        <SelectableList
          values={colorsListValue}
          options={colorsOptions}
          onChange={onSelectableColorsListChange}
        />
      </FilterAccordion>
    </Accordion>
  );
};

export default ColorsFilter;
